import React, { useState, useEffect } from 'react';
import Swal from 'sweetalert2';
import { getOrderByPaymentOrderID } from '../api/paymentAPI';
import Helmet from 'react-helmet';
import DOMPurify from 'dompurify';

const Invoice = (props) => {

    const [invoice,        setInvoice]          = useState();

    const queryParameters = new URLSearchParams(window.location.search);
    const paymentOrderID = queryParameters.get("id");

    useEffect(() => {

        if (paymentOrderID) {
            verifyHandler(paymentOrderID);
        } 
        else {
            Swal.close();
            Swal.fire({
                icon              : "error",
                titleText         : "Error: Invoice not found",
                showConfirmButton   : false,
                allowOutsideClick   : false
            })
        }
    }, []);

    const verifyHandler = async (paymentOrderID) => {
        try {
            Swal.fire({
                titleText           : 'Loading',
                text                : 'Please Wait...',
                showConfirmButton   : false,
                allowOutsideClick   : false,
                onOpen: () => {
                    Swal.showLoading();
                }
            });
            const response = await getOrderByPaymentOrderID(paymentOrderID);
            setInvoice(response.InvoiceData);
            Swal.close();
        } catch (err) {
            Swal.close();
            Swal.fire({
                icon              : "error",
                titleText         : err.message,
                showConfirmButton : false,
                allowOutsideClick : false
            })
            return;  
        }
    }

    return(
        <div>
            <Helmet>
                <meta name="viewport" content="" />
            </Helmet>
            <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(invoice) }}/>
        </div>
    )
}

export default Invoice;